module.exports = __webpack_public_path__ + "static/abaclick-04839037196ec88226cb489895a2478c.jpg";